import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-2" }
const _hoisted_2 = { class: "ml-5 list-disc" }
const _hoisted_3 = { class: "mt-4 font-semibold" }

import { Company } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import Delete from '@/components/Delete.vue';
    import EditCompany from '@/components/companies/EditCompany.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';

    interface Props {
        company: Company;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyTableActions',
  props: {
    company: {}
  },
  setup(__props: any) {

    

    const { hasPermission } = usePermissions();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTableActions, { data: _ctx.company }, {
    default: _withCtx(() => [
      _createVNode(EditCompany, { company: _ctx.company }, null, 8, ["company"]),
      (_unref(hasPermission)(_unref(Permission).COMPANIES_DELETE))
        ? (_openBlock(), _createBlock(Delete, {
            key: 0,
            route: _ctx.route('v2.companies.destroy', { id: _ctx.company.id }),
            "query-key": [_unref(QueryKey).COMPANIES],
            "success-message": "companies.deleted",
            "error-message": "companies.delete.error",
            "continue-button-text": "companies.js.delete.title",
            header: "companies.js.delete.header"
          }, {
            description: _withCtx(() => [
              _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t('companies.js.delete.will_delete')), 1),
              _createElementVNode("ul", _hoisted_2, [
                _createElementVNode("li", null, _toDisplayString(_ctx.$t('companies.js.delete.deleted_rows.users')), 1),
                _createElementVNode("li", null, _toDisplayString(_ctx.$t('companies.js.delete.deleted_rows.payrolls')), 1),
                _createElementVNode("li", null, _toDisplayString(_ctx.$t('companies.js.delete.deleted_rows.pay_slips')), 1),
                _createElementVNode("li", null, _toDisplayString(_ctx.$t('companies.js.delete.deleted_rows.employees')), 1)
              ]),
              _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('companies.js.delete.cannot_be_undone')), 1)
            ]),
            _: 1
          }, 8, ["route", "query-key"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})